(function () {
  'use strict';

  const apiKey = 'SLRMainProductAudio';

  if (window[apiKey] && typeof window[apiKey].initAll === 'function') {
    window[apiKey].initAll(document);
    return;
  }

  const controllers = new WeakMap();

  function rootsWithin(container) {
    const roots = [];

    if (container instanceof Element && container.matches('[data-audio-hero-section]')) {
      roots.push(container);
    }

    if (container && typeof container.querySelectorAll === 'function') {
      container.querySelectorAll('[data-audio-hero-section]').forEach(function (root) {
        roots.push(root);
      });
    }

    return roots;
  }

  function destroy(root) {
    const controller = controllers.get(root);
    if (controller) controller.abort();
    controllers.delete(root);
    delete root.dataset.audioHeroLockInitialized;
  }

  function init(root) {
    if (!root || controllers.has(root)) return;

    const checkbox = root.querySelector('[data-slra-consent]');
    const overlay = root.querySelector('.slra-lock__overlay');
    const inner = root.querySelector('.slra-lock__inner');
    const error = root.querySelector('.slra-error');
    const widerrufToggle = root.querySelector('[data-slra-widerruf-toggle]');
    const widerrufPanel = root.querySelector('[data-slra-widerruf-panel]');
    const popupTarget = root.querySelector('[data-slra-terms-popup]');

    if (!checkbox) return;

    const abortController = new AbortController();
    const listenerOptions = { signal: abortController.signal };
    controllers.set(root, abortController);
    root.dataset.audioHeroLockInitialized = 'true';

    function setLockedElementsFocusability(disabled) {
      if (!inner) return;

      inner.querySelectorAll('a, button, input, select, textarea, iframe, [tabindex]').forEach(function (element) {
        if (disabled) {
          if (!element.hasAttribute('data-slra-original-tabindex')) {
            element.setAttribute('data-slra-original-tabindex', element.getAttribute('tabindex') || '');
          }
          element.setAttribute('tabindex', '-1');
        } else {
          const originalTabindex = element.getAttribute('data-slra-original-tabindex');
          if (originalTabindex === '') {
            element.removeAttribute('tabindex');
          } else if (originalTabindex !== null) {
            element.setAttribute('tabindex', originalTabindex);
          }
          element.removeAttribute('data-slra-original-tabindex');
        }
      });
    }

    function setPurchaseLockState() {
      if (overlay && inner && error) {
        if (checkbox.checked) {
          overlay.classList.add('hidden');
          overlay.setAttribute('aria-hidden', 'true');
          overlay.setAttribute('tabindex', '-1');
          inner.classList.add('active');
          inner.removeAttribute('inert');
          inner.setAttribute('aria-hidden', 'false');
          setLockedElementsFocusability(false);
          error.style.display = 'none';
          checkbox.setAttribute('aria-invalid', 'false');
        } else {
          overlay.classList.remove('hidden');
          overlay.setAttribute('aria-hidden', 'false');
          overlay.setAttribute('tabindex', '0');
          inner.classList.remove('active');
          inner.setAttribute('inert', '');
          inner.setAttribute('aria-hidden', 'true');
          setLockedElementsFocusability(true);
        }
      }
    }

    function showTermsError() {
      if (error) error.style.display = 'block';
      checkbox.setAttribute('aria-invalid', 'true');
      checkbox.style.outline = '2px solid #ef3a12';
      checkbox.style.outlineOffset = '2px';

      if (typeof checkbox.focus === 'function') {
        checkbox.focus({ preventScroll: true });
      }

      window.setTimeout(function () {
        if (!checkbox.isConnected) return;
        checkbox.style.outline = '';
        checkbox.style.outlineOffset = '';
      }, 1000);
    }

    function setWiderrufPanelState(isOpen) {
      if (!widerrufToggle || !widerrufPanel) return;

      widerrufToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      widerrufPanel.hidden = !isOpen;
      widerrufPanel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    if (widerrufToggle && widerrufPanel) {
      widerrufToggle.addEventListener('click', function () {
        const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
        setWiderrufPanelState(!isOpen);
      }, listenerOptions);

      widerrufToggle.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const isOpen = widerrufToggle.getAttribute('aria-expanded') === 'true';
        setWiderrufPanelState(!isOpen);
      }, listenerOptions);

      setWiderrufPanelState(false);
    }

    if (popupTarget) {
      const magnifier = popupTarget.querySelector('.slra-terms__magnifier');
      const popup = popupTarget.querySelector('.slra-terms__popup');
      const closeBtn = popupTarget.querySelector('.slra-terms__popup-close');

      function isTouchMode() {
        return window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
      }

      function showMagnifier() {
        popupTarget.classList.add('is-magnifier-visible');
        if (magnifier) magnifier.setAttribute('aria-expanded', 'false');
      }

      function hideMagnifier() {
        popupTarget.classList.remove('is-magnifier-visible');
      }

      function openPopup(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        popupTarget.classList.add('is-info-active');
        popupTarget.classList.add('is-magnifier-visible');
        if (popup) popup.setAttribute('aria-hidden', 'false');
        if (magnifier) magnifier.setAttribute('aria-expanded', 'true');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus({ preventScroll: true });
      }

      function closePopup(event, returnFocus) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        popupTarget.classList.remove('is-info-active');
        if (popup) popup.setAttribute('aria-hidden', 'true');

        if (magnifier) {
          magnifier.setAttribute('aria-expanded', 'false');
          if (returnFocus && typeof magnifier.focus === 'function') magnifier.focus({ preventScroll: true });
        }

        if (isTouchMode()) hideMagnifier();
      }

      function closeAll(returnFocus) {
        closePopup(null, returnFocus);
        hideMagnifier();
      }

      if (magnifier) {
        magnifier.addEventListener('click', openPopup, listenerOptions);
        magnifier.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') openPopup(event);
        }, listenerOptions);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (event) { closePopup(event, true); }, listenerOptions);
        closeBtn.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') closePopup(event, true);
        }, listenerOptions);
      }

      if (popup) {
        popup.addEventListener('click', function (event) { event.stopPropagation(); }, listenerOptions);
        popup.addEventListener('pointerdown', function (event) { event.stopPropagation(); }, listenerOptions);
      }

      popupTarget.addEventListener('click', function (event) {
        if (!isTouchMode()) return;
        if (event.target.closest('.slra-terms__magnifier')) return;
        if (event.target.closest('.slra-terms__popup')) return;
        if (event.target.closest('a')) return;

        if (event.target.closest('label')) {
          showMagnifier();
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (popupTarget.classList.contains('is-info-active')) {
          closePopup(null, false);
          return;
        }

        popupTarget.classList.toggle('is-magnifier-visible');
      }, listenerOptions);

      document.addEventListener('click', function (event) {
        if (!popupTarget.contains(event.target)) closeAll(false);
      }, listenerOptions);

      document.addEventListener('pointerdown', function (event) {
        if (!popupTarget.contains(event.target)) closeAll(false);
      }, listenerOptions);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeAll(true);
          setWiderrufPanelState(false);
        }
      }, listenerOptions);

      window.addEventListener('resize', function () { closeAll(false); }, listenerOptions);
    }

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showTermsError();
      }, listenerOptions);

      overlay.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        showTermsError();
      }, listenerOptions);
    }

    checkbox.addEventListener('change', setPurchaseLockState, listenerOptions);
    setPurchaseLockState();
  }

  function initAll(container) {
    rootsWithin(container || document).forEach(init);
  }

  function destroyAll(container) {
    rootsWithin(container || document).forEach(destroy);
  }

  window[apiKey] = { initAll: initAll, destroyAll: destroyAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
